import styled from "@emotion/styled";
import { CSS_COLORS, CSS_SPACER_SIZES } from "../../../../../styles/styles-css-variables";
import { CSS_MQ } from "../../../../../styles/breakpoints";
import { FONTS, fontSize } from "../../../../../styles/fonts";
import { css } from "@emotion/react";

const styles = css`
  color: ${CSS_COLORS.Green};

  text-align: center;

  text-transform: uppercase;

  margin-bottom: 20px;
  ${CSS_MQ.atLeastMd} {
    margin-bottom: ${CSS_SPACER_SIZES.md};
  }
`;

export const CheckoutHeadline = styled.h1([FONTS.SwarovskiFutura300, fontSize.x6, styles]);
export const CheckoutSubheadline = styled.h2([FONTS.SwarovskiFutura300, fontSize.x5, styles]);
